import { useEffect } from 'react';

// Fallback for routes that moved to the partner domain. nginx should 301 these
// too; this keeps them working if it hasn't been updated yet.
export default function ExternalRedirect({ to }) {
    useEffect(() => {
        window.location.replace(to);
    }, [to]);

    return null;
}
